export default {
    EXAME: 1,
    LABORATORIO: 2,
    UNIDADE_SOLICITANTE: 3
}
